import { useTranslation } from 'react-i18next';

import logo from './EuropeanCommissionLogo.png';
import * as Styled from './PoweredBy.styles';

type Props = {
  className?: string;
};

const PoweredBy = ({ className }: Props) => {
  const { t } = useTranslation();

  return (
    <Styled.PoweredByContainer className={className}>
      <Styled.PoweredByLogo src={logo} alt="European Commission" />
      <Styled.PoweredByText>
        {t('poweredBy.poweredBy')}&nbsp;
        <span>{t('poweredBy.billon')}</span>
      </Styled.PoweredByText>
      <Styled.VersionText>{`${process.env.REACT_APP_BUILD_DATE}_v ${process.env.REACT_APP_VERSION}`}</Styled.VersionText>
    </Styled.PoweredByContainer>
  );
};

export default PoweredBy;
